/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type GovernanceMeetingBanner_circle$ref = any;
type TacticalMeetingBanner_circle$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MeetingBanners_organization$ref: FragmentReference;
declare export opaque type MeetingBanners_organization$fragmentType: MeetingBanners_organization$ref;
export type MeetingBanners_organization = {|
  +databaseId: string,
  +viewer: {|
    +circles: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +$fragmentRefs: GovernanceMeetingBanner_circle$ref & TacticalMeetingBanner_circle$ref,
        |}
      |}>
    |}
  |},
  +$refType: MeetingBanners_organization$ref,
|};
export type MeetingBanners_organization$data = MeetingBanners_organization;
export type MeetingBanners_organization$key = {
  +$data?: MeetingBanners_organization$data,
  +$fragmentRefs: MeetingBanners_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingBanners_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "canAttendMeetings",
              "value": true
            }
          ],
          "concreteType": "CircleConnection",
          "kind": "LinkedField",
          "name": "circles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CircleEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Circle",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "GovernanceMeetingBanner_circle"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "TacticalMeetingBanner_circle"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "circles(canAttendMeetings:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '58a34298b9d4da02f698cf0f68289baf';

module.exports = node;
